module.exports = __webpack_public_path__ + "static/media/close.d2eac24c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/close.svg
// module id = 155
// module chunks = 0